import { render, staticRenderFns } from "./PaymentSpendSuccess.vue?vue&type=template&id=8766bc90&"
import script from "./PaymentSpendSuccess.vue?vue&type=script&lang=js&"
export * from "./PaymentSpendSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports